export default "__VITE_ASSET__cd976068__"